<template>
    <div id="pc_index">
        <div class="maskbox" v-show="isHovered"></div>
        <div class="backimg"><img src="../assets/headerimg.png" fit="cover"></div>
        <div class="header flex">
            <img src="../assets/logo.png" class="logo">
            <div class="nav flex">
                <div class="flex box" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                    <div class="txttxt"><a href="">参观指南</a><div class="lineline"></div></div>
                    <div class="whitebox">
                        <div class="flex"><p>时间与地址</p><p>购买门票</p><p>艺术品商店</p><p>电子导览（手册）</p></div>
                    </div>
                </div>
                <div class="flex box" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                    <div class="txttxt"><a href="">展览活动</a><div class="lineline"></div></div>
                    <div class="whitebox">
                        <div class="flex"><p>正在展出</p><p>当前活动</p><p>过往展览</p><p>往期活动（精选）</p></div>
                    </div>
                </div>
                <div class="flex box" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                    <div class="txttxt"><a href="">服务与公益</a><div class="lineline"></div></div>
                    <div class="whitebox">
                        <div class="flex"><p>馆方服务</p><p>公益讲解</p><p>公益合作</p><p>志愿者报名</p></div>
                    </div>
                </div>
                <div class="flex box" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                    <div class="txttxt"><a href="">媒体中心</a><div class="lineline"></div></div>
                    <div class="whitebox">
                        <div class="flex"><p>三方报道</p><p>馆藏信息</p><p>“360全景展示”</p><p>关于我们（含媒体资料下载）</p></div>
                    </div>
                </div>
            </div>
            <img src="../assets/search.png" class="search">
            <div class="flex box"><p>中文</p><img src="../assets/zhuan.png"></div>
        </div>
        <div class="bigimg"><img src="../assets/headerimg.png"></div>
        <div class="timadd flex">
            <div class="one">
                <img src="../assets/backimg.png" alt="">
                <div class="dark">
                    <h2>开放时间</h2>
                    <div class="tim flex">
                        <img src="../assets/search.png">
                        <h2>10:00~18:00</h2>
                    </div>
                    <p>17:30后停止入场，除法定节假日外，周一闭馆</p>
                    <div class="btn flex"><p>查看更多</p><img src="../assets/zhuan.png"></div>
                </div>
            </div>
            <div class="one">
                <img src="../assets/backimg.png" alt="">
                <div class="dark">
                    <h1>民生现代美术馆</h1>
                    <h1>电子导览</h1>
                    <div class="btn flex"><p>马上查看</p><img src="../assets/zhuan.png"></div>
                </div>
            </div>
        </div>
        <div class="hot">
            <p class="tit">热门展览/活动</p>
            <div class="huodong">
                <div class="leftimg flex">
                    <img src="../assets/right.png" alt="" class="zhutu">
                    <div class="blackbox">
                        <div class="tips">展览</div>
                        <h1>文明的起源——早期中华文明探寻大展</h1>
                        <p>2024.1.13-2024.7.13</p>
                        <p>一展厅/一层大厅</p>
                        <div class="btn flex"><p>详情页面</p><img src="../assets/zhuan.png"></div>
                    </div>
                </div>
                <div class="leftimg flex">
                    <div class="blackbox">
                        <div class="tips">展览</div>
                        <h1>文明的起源——早期中华文明探寻大展</h1>
                        <p>2024.1.13-2024.7.13</p>
                        <p>一展厅/一层大厅</p>
                        <div class="btn flex"><p>详情页面</p><img src="../assets/zhuan.png"></div>
                    </div>
                    <img src="../assets/right.png" alt="" class="zhutu">
                </div>
            </div>
            <div class="tolist flex">
                <div class="btn flex"><p>查看全部当前活动</p><img src="../assets/zhuan.png"></div>
                <div class="btn flex"><p>查看全部正在展出</p><img src="../assets/zhuan.png"></div>
            </div>
        </div>
        <div class="toggle">
            <div class="heiqie">
                <div class="qie flex">
                    <div class="btn flex" :class="{ 'act': activeTab == 0 }" @click="activateTab(0)"><p>过往展览</p><img src="../assets/zhuan.png"></div>
                    <div class="btn flex" :class="{ 'act': activeTab == 1 }" @click="activateTab(1)"><p>往期活动</p><img src="../assets/zhuan.png"></div>
                </div>
            </div>
            <div class="qielist flex">
                <div class="listbox" v-for="(item, index) in arrList" :index="index">
                    <img src="../assets/list1.png">
                    <h3>文明的起源——早期中华文明探寻大展</h3>
                    <p>2024.1.13-2024.7.13</p>
                </div>
            </div>
            <div class="tolist flex">
                <div class="btn flex"><p>查看全部过往展出</p><img src="../assets/zhuan.png"></div>
            </div>
        </div>
        <div class="friends">
            <p class="tit">友情链接</p>
            <div class="qielist flex">
                <div class="listbox" v-for="(item, index) in arrList" :index="index">
                    <img src="../assets/list2.png">
                    <p>早期中华文明探寻大展</p>
                </div>
            </div>
            <div class="tolist flex">
                <div class="btn flex"><p>艺术品商店</p><img src="../assets/zhuan.png"></div>
                <div class="btn flex"><p>志愿者报名</p><img src="../assets/zhuan.png"></div>
            </div>
        </div>
        <div class="footimg"><img src="../assets/foot.png"></div>
    </div>
</template>

<script setup>
    import { ref, watch, onBeforeUnmount } from 'vue';
    const activeTab = ref(0);
    const isHovered = ref(false);
    const arrList = ref([1,1,1,1,1,1,1,1,1,1]);
    // 切换
    function activateTab(num) {
        activeTab.value = num;
    }
    function handleMouseEnter(){
        isHovered.value = true;
    }
    function handleMouseLeave(){
        isHovered.value = false;
    }
</script>

<style scoped>
    #pc_index{
        overflow: hidden;
    }
    .backimg{
        position: relative;
        img{
            position: fixed;
            width: 100%;
            height: 100vh;
            z-index: -1;
            top: 0;
            left: 0;
        }
    }
    .header{
        position: fixed;
        width: 100%;
        height: 120px;
        margin: 0 auto;
        padding: 0 120px;
        background: white;
        box-sizing: border-box;
        z-index: 1;
        .logo{
            width: 180px;
            margin-right: 30px;
        }
        .nav{
            flex: 1;
            justify-content: flex-start;
        }
        
        .box{
            padding: 0 20px;
            cursor: pointer;
            .txttxt{
                position: relative;
                font-size: 16px;
                color: black;
                line-height: 120px;
            }
            img{
                width: 6px;
                margin-left: 10px;
                transform: rotate(90deg);
            }
            
            &:hover .txttxt a{
                font-weight: bold;
            }
        }
        .search{
            width: 20px;
            margin-right: 10px;
        }
        .lineline{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 2px;
            background: black;
            transition: width .6s;
        }
        .whitebox{
            border-top: 2px solid #f0f0f0;
            position: fixed;
            width: 100%;
            height: 0;
            background: white;
            top: 120px;
            left: 0;
            padding: 0 100px;
            box-sizing: border-box;
            visibility: hidden;
            transition: height .5s ease-in .5s, visibility .5s ease-in .5s;
            >div{
                height: 200px;
                opacity: 0;
                transition: opacity .5s;
                p{
                    margin: 0 100px;
                    &:hover{
                        color: #bfbfbf;
                    }
                }
            }
        }
        .box:hover .whitebox{
            height: 200px;
            visibility: visible;
            transition: height .5s ease-in;
        }
        .box:hover .whitebox>div{
            opacity: 1;
            transition: opacity .5s .5s;
        }
        .box:hover .lineline{
            width: 70px;
            transition: width .6s;
        }
    }
    .bigimg{
        margin-top: 120px;
        width: 100%;
        img{
            width: 100%;
            height: auto;
            display: block;
        }
    }
    .timadd{
        box-sizing: border-box;
        width: 100%;
        padding: 92px 110px;
        background: white;
        margin-bottom: 116px;
        .one{
            position: relative;
            color: white;
            text-align: center;
            img{
                width: 600px;
                height: 360px;
            }
            .dark{
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: rgba(0, 0, 0, .8);
                box-sizing: border-box;
                padding: 60px 0;
                h1{
                    margin-bottom: 15px;
                }
                
                .btn{
                    cursor: pointer;
                    position: absolute;
                    bottom: 40px;
                    left: 50%;
                    margin-left: -130px;
                    color: black;
                    font-size: 24px;
                    background: white;
                    width: 260px;
                    height: 60px;
                    box-sizing: border-box;
                    padding: 0 20px 0 30px;
                    font-weight: bold;
                    img{
                        width: 6px;
                        height: 12px;
                    }
                }
                .btn:hover{
                    background: black;
                    color: white;
                    border: 1px solid white;
                }
                .tim{
                    justify-content: center;
                    margin: 20px 0;
                }
                img{
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                }
            }
        }
    }
    
    .hot{
        background: white;
        margin-bottom: 116px;
        .huodong{
            box-sizing: border-box;
            width: 100%;
            padding: 0 110px;
            background: white;
            .zhutu{
                width: 50%;
                height: 100%;
            }
            .leftimg{
                text-align: left;
                height: 586px;
                .blackbox{
                    width: 50%;
                    height: 100%;
                    color: white;
                    box-sizing: border-box;
                    padding: 45px;
                    background: #232323;
                    .tips{
                        width: 100px;
                        height: 40px;
                        font-size: 24px;
                        color: #232323;
                        background: white;
                        text-align: center;
                        font-weight: bold;
                        margin: 30px 0;
                    }
                    h1{
                        font-size: 50px;
                        margin-bottom: 40px;
                    }
                    p{
                        font-size: 25px;
                    }
                    .btn{
                        cursor: pointer;
                        color: black;
                        font-size: 24px;
                        background: white;
                        width: 260px;
                        height: 60px;
                        box-sizing: border-box;
                        padding: 0 20px 0 30px;
                        font-weight: bold;
                        margin-top: 40px;
                        img{
                            width: 6px;
                            height: 12px;
                        }
                    }
                    .btn:hover{
                        background: black;
                        color: white;
                        border: 1px solid white;
                    }
                }
                
            }
        }
    }
    
    .tolist{
        padding: 116px 0;
        justify-content: center;
        .btn{
            cursor: pointer;
            color: white;
            font-size: 24px;
            background: black;
            width: 300px;
            height: 60px;
            box-sizing: border-box;
            padding: 0 20px 0 30px;
            font-weight: bold;
            margin: 0 50px;
            img{
                width: 6px;
                height: 12px;
            }
        }
        .btn:hover{
            background: white;
            color: black;
            border: 1px solid black;
        }
    }
    .tit{
        font-size: 40px;
        color: #232323;
        font-weight: bold;
        text-align: center;
        line-height: 160px;
    }
    .toggle{
        box-sizing: border-box;
        width: 100%;
        padding: 90px 110px 0;
        background: white;
        margin-bottom: 116px;
        .heiqie{
            width: 100%;
            height: 150px;
            background: #232323;
            .qie{
                justify-content: center;
                font-weight: bold;
                font-size: 36px;
                text-align: center;
                color: white;
                .btn{
                    cursor: pointer;
                    flex-direction: column;
                    justify-content: space-around;
                    width: 49%;
                    height: 130px;
                    margin-top: 20px;
                }
                .act{
                    background: white;
                    color: black;
                }
                img{
                    transform: rotate(90deg);
                }
            }
        }
    }
    
    .qielist{
        flex-wrap: wrap;
        justify-content: flex-start;

        .listbox{
            width: 300px;
            text-align: left;
            margin: 100px 12px 0;
        }
        img{
            width: 100%;
            height: 385px;
        }
        h3{
            font-size: 21px;
            margin: 10px 0 30px 0;
        }
        p{
            font-size: 19px;
            color: #7c7c7c;
            font-weight: bold;
        }
    }
    .friends{
        margin-bottom: 0;
        .tit{
            background: white;
        }
        .qielist{
            padding: 40px 110px 0;
            .listbox{
                width: 163px;
                border: 6px solid white;
                margin: 0 18px 40px;
                min-height: 230px;
                background: black;
                img{
                    width: 100%;
                    height: 180px;
                }
                p{
                    color: white;
                    text-align: center;
                    font-weight: normal;
                    padding: 4px;
                    font-size: 18px;
                }
            }
        }
        .tolist{
            background: white;
            .btn{
                width: 680px;
                height: 100px;
                font-size: 40px;
            }
        }
    }
    .footimg{
        margin: 0;
        width: 100%;
        height: auto;
    }
</style>